var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVpnKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6924 15.3845H13.077V12.3075H11.0154C10.1385 14.1691 8.24621 15.3845 6.1539 15.3845C3.18467 15.3845 0.769287 12.9691 0.769287 9.99985C0.769287 7.03062 3.18467 4.61523 6.1539 4.61523C8.24621 4.61523 10.1308 5.83062 11.0154 7.69216H19.2308V12.3075H17.6924V15.3845ZM14.6154 13.846H16.1539V10.7691H17.6924V9.23062H9.9539L9.77698 8.71523C9.23852 7.18447 7.77698 6.1537 6.1539 6.1537C4.03083 6.1537 2.30775 7.87677 2.30775 9.99985C2.30775 12.1229 4.03083 13.846 6.1539 13.846C7.77698 13.846 9.23852 12.8152 9.77698 11.2845L9.9539 10.7691H14.6154V13.846ZM6.1539 12.3075C4.88467 12.3075 3.84621 11.2691 3.84621 9.99985C3.84621 8.73062 4.88467 7.69216 6.1539 7.69216C7.42313 7.69216 8.46159 8.73062 8.46159 9.99985C8.46159 11.2691 7.42313 12.3075 6.1539 12.3075ZM6.1539 9.23062C5.73082 9.23062 5.38467 9.57677 5.38467 9.99985C5.38467 10.4229 5.73082 10.7691 6.1539 10.7691C6.57698 10.7691 6.92313 10.4229 6.92313 9.99985C6.92313 9.57677 6.57698 9.23062 6.1539 9.23062Z",
    fill: "#A39689"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4615,
    height: 18.4615,
    fill: "white",
    transform: "translate(0.769287 0.769531)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpnKey);
export default __webpack_public_path__ + "static/media/vpn-key.db7637660e4ddefffdb3286641e9a6c3.svg";
export { ForwardRef as ReactComponent };